import React, { useMemo } from 'react';
import { Box, Grid, Container } from '@mui/material';
import { useSelector } from 'react-redux';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { DistrictLocations } from 'views/rebranded-module/location-module/LocationsViewV2/components';
import { FILTER_TYPE } from 'views/rebranded-module/location-module/LocationsViewV2/utils/constants';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/DesktopLocationList/DesktopLocationList.styles';
import { Typography700 } from 'views/rebranded-module/common/components';

const DesktopLocationList = (props) => {
  const {
    usCountry,
    filteredUsLocations,
    filteredNonUsLocations,
    filter,
    defaultVehicleType,
    content,
  } = props;
  const showMembership = useSelector(
    (state) => state.globalData.showMembership,
  );

  const memoizedFilteredUsLocations = useMemo(
    () => filteredUsLocations.map((location) => (
      <Grid item mb={4} lg={4} md={6} key={location.region.name}>
        <DistrictLocations
          district={location}
          membershipEnabled={showMembership}
          defaultVehicleType={defaultVehicleType}
          content={content}
          />
      </Grid>
    )),
    [filteredUsLocations],
  );
  const memoizedFilteredNonUsLocations = useMemo(
    () => filteredNonUsLocations.map((location) => (
      <Grid item mb={4} lg={4} md={6} key={location.region.name}>
        <DistrictLocations
          district={location}
          membershipEnabled={showMembership}
          defaultVehicleType={defaultVehicleType}
          content={content}
          />
      </Grid>
    )),
    [filteredNonUsLocations],
  );
  const shouldRemoveBg = () => filter === FILTER_TYPE.INTERNATIONAL
    || (filter !== FILTER_TYPE.ALL_LOCATIONS && filter !== FILTER_TYPE.CLUB);

  return (
    <StyledBox className="showTabletAndDesktop">
      {(filter === FILTER_TYPE.ALL_LOCATIONS
        || filter === FILTER_TYPE.CLUB
        || filter === FILTER_TYPE.US)
        && filteredUsLocations.length > 0 && (
          <Box>
            <Container maxWidth="xl">
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <NavigatorLink
                    className="DLLHeaderLink"
                    href={PATHS.geoSlug([
                      defaultVehicleType.slug,
                      usCountry.slug,
                    ])}>
                    <Typography700
                      variant="h3"
                      component="p"
                      className="DLLocationsTitle">
                      {usCountry.name}
                    </Typography700>
                  </NavigatorLink>
                </Grid>
                {memoizedFilteredUsLocations}
              </Grid>
            </Container>
          </Box>
      )}

      {(filter === FILTER_TYPE.ALL_LOCATIONS
        || filter === FILTER_TYPE.CLUB
        || filter === FILTER_TYPE.INTERNATIONAL)
        && filteredNonUsLocations.length > 0 && (
          <Box
            className={`DLInternationLocations ${
              shouldRemoveBg(filter) ? 'DLRemoveBg' : ''
            }`}>
            <Container maxWidth="xl">
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Typography700
                    variant="h3"
                    component="p"
                    className="DLLocationsTitle">
                    {content.internationalLocations}
                  </Typography700>
                </Grid>
                {memoizedFilteredNonUsLocations}
              </Grid>
            </Container>
          </Box>
      )}
    </StyledBox>
  );
};

export { DesktopLocationList };
